module.exports = __webpack_public_path__ + "img/globe.1f3743a3.svg";